@if (file().fileType.startsWith('LMA_')) {
  <ng-icon name="documentTypeLma" size="{{ size() }}" class="!block" />
} @else if (file().mimeType.startsWith('image/')) {
  <ng-icon name="documentTypeImage" size="{{ size() }}" class="!block" />
} @else if (file().mimeType.startsWith('audio/')) {
  <ng-icon name="documentTypeAudio" size="{{ size() }}" class="!block" />
} @else if (file().mimeType.startsWith('video/')) {
  <ng-icon name="documentTypeVideo" size="{{ size() }}" class="!block" />
} @else if (file().mimeType.startsWith('text/plain')) {
  <ng-icon name="documentTypeText" size="{{ size() }}" class="!block" />
} @else if (
  ['text/html', 'application/json'].some((mimeType) => file().mimeType.startsWith(mimeType))
) {
  <ng-icon name="documentTypeCode" size="{{ size() }}" class="!block" />
} @else {
  @switch (file().mimeType) {
    @case ('application/pdf') {
      <ng-icon name="documentTypePdf" size="{{ size() }}" class="!block" />
    }
    @case ('application/zip') {
      <ng-icon name="documentTypeZip" size="{{ size() }}" class="!block" />
    }
    @case ('text/csv') {
      <ng-icon name="documentTypeCsv" size="{{ size() }}" class="!block" />
    }
    @case ('application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      <ng-icon name="documentTypeDocx" size="{{ size() }}" class="!block" />
    }
    @case ('application/msword') {
      <ng-icon name="documentTypeDoc" size="{{ size() }}" class="!block" />
    }
    @case ('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      <ng-icon name="documentTypeXlsx" size="{{ size() }}" class="!block" />
    }
    @default {
      <ng-icon
        name="heroDocument"
        size="{{ size() }}"
        class="!block"
        [uiTooltip]="file().mimeType"
      />
    }
  }
}
